/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { PageTitleModel } from '@core/aem/components/page-title-template/models/page-title-template.model';

@Component({
  selector: 'tmo-page-title-template',
  templateUrl: './page-title-template.component.html',
  styleUrls: ['../../../../../style-sheets/components/page-titles.component.scss'],
})

// TODO: This is a temporary solution to solving page title AEM data
// TODO: We need to discuss this at large as it doesn't present an authorable way to present AEM data.
export class PageTitleTemplateComponent
  extends AuthorableComponent<PageTitleModel>
  implements OnInit, OnDestroy
{
  /**
   * The page title.
   */
  public pageTitle: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }

  /**
   * Component init.
   */
  public ngOnInit(): void {}

  /**
   * set AEM data.
   */
  public setData(data: PageTitleModel): void {
    this.pageTitle = data && data.pageTitle ? data.pageTitle.replace(/<(?:.|\n)*?>/gm, '') : '';
  }

  /**
   * Component Clean-up.
   */
  public ngOnDestroy(): void {}
}
